import { Button, message, Modal } from "antd";

import api from "services/api.service";

interface IProps {
  getContactsList: () => void;
  deletingContact: any;
  setDeletingContact: (contact: any) => void;
}

const ContractorContactDeleteModal = ({
  getContactsList,
  deletingContact,
  setDeletingContact,
}: IProps) => {
  const handleContactDelete = async () => {
    try {
      await api.contactDelete(deletingContact.id);

      message.success("Contact was deleted.");
      setDeletingContact(null);
      await getContactsList();
    } catch (e: any) {
      message.error(e.response.data.error || e.error || "Something went wrong!");
    }
  };
  
  return (
    <Modal
      className="user-accept-modal-wrapper"
      open={ !!deletingContact }
      onCancel={ () => setDeletingContact(null) }
      footer={ null }
      width={ 500 }
    >
      <>
        <h4 className="modal-title">
          Are you sure you want to delete
          {" "}
          <span>{ deletingContact?.first_name } { deletingContact?.last_name }</span>?
        </h4>

        <div className="action-wrapper">
          <Button
            type="primary"
            onClick={ handleContactDelete }
          >
            Yes
          </Button>

          <Button onClick={ () => setDeletingContact(null) }>
            No
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default ContractorContactDeleteModal;
